import { GetterTree } from "vuex";
import { FavoritesState, RootState } from "@/types/favorites";
import NativeClient from "@/client/native-client";

const getters: GetterTree<FavoritesState, RootState> = {
  getAddRecipeResult: (state: FavoritesState) => {
    return state.addRecipeResult;
  },
  getDeleteRecipeResult: (state: FavoritesState) => {
    return state.deleteRecipeResult;
  },
  getRecentMyList: (state: FavoritesState) => {
    NativeClient.sendDebugLog("Getters.ts getRecentMyList totalCount = " + state.recentMylist?.totalCount);
    NativeClient.sendDebugLog("Getters.ts getRecentMyList recipeList.count = " + state.recentMylist?.clips.length);
    return state.recentMylist;
  },
  getMyList: (state: FavoritesState) => {
    NativeClient.sendDebugLog("Getters.ts getMyList totalCount = " + state.mylist?.totalCount);
    NativeClient.sendDebugLog("Getters.ts getMyList recipeList.count = " + state.mylist?.clips.length);
    return state.mylist;
  },
  getFolderRecipeList: (state: FavoritesState) => {
    NativeClient.sendDebugLog("Getters.ts getFolderRecipeList totalCount = " + state.folderRecipeList?.totalCount);
    NativeClient.sendDebugLog("Getters.ts getFolderRecipeList recipeList.count = " + state.folderRecipeList?.clips.length);
    return state.folderRecipeList;
  },
  getFolderList: (state: FavoritesState) => {
    return state.folderList;
  },
  getRegistFolderResult: (state: FavoritesState) => {
    return state.registFolderResult;
  },
  getRenameFolderResult: (state: FavoritesState) => {
    return state.renameFolderResult;
  },
  getDeleteFolderResult: (state: FavoritesState) => {
    return state.deleteFolderResult;
  },
  getAddFolderRecipeResult: (state: FavoritesState) => {
    return state.addFolderRecipeResult;
  },
  getDeleteFolderRecipeResult: (state: FavoritesState) => {
    return state.deleteFolderRecipeResult;
  },
  getFolderMoveResult: (state: FavoritesState) => {
    return state.folderMoveResult;
  },
  getFolderName: (state: FavoritesState) => {
    return state.folderName;
  },
  getSendedHistory: (state: FavoritesState) => {
    return state.sendedHistory;
  },
  getViewedHistory: (state: FavoritesState) => {
    return state.viewedHistory;
  },
  getSelectedTab: (state: FavoritesState) => {
    return state.selectedTab;
  }
};

export default getters;
